import { z } from 'zod';
export const OtpRequestSchema = z.object({
    phone: z.string().regex(/^\+216[0-9]{8}$/, 'Numéro de téléphone tunisien invalide'),
});
export const OtpVerifySchema = z.object({
    phone: z.string().regex(/^\+216[0-9]{8}$/, 'Numéro de téléphone tunisien invalide'),
    code: z.string().length(6, 'Code OTP doit contenir 6 chiffres'),
});
export const AuthTokensSchema = z.object({
    accessToken: z.string(),
    refreshToken: z.string(),
    expiresIn: z.number(),
});
